import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnDialogComponent } from './dn-dialog.component';
import { DnDialogCloseButtonComponent } from './dn-dialog-close-button/dn-dialog-close-button.component';
import { DnDialogButtonComponent } from './dn-dialog-button/dn-dialog-button.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DnDialogComponent,
    DnDialogCloseButtonComponent,
    DnDialogButtonComponent
    
  ],
  exports: [
    DnDialogComponent,
    DnDialogCloseButtonComponent,
    DnDialogButtonComponent

  ],
  providers: [
    // DnDialogService
  ]
})

export class DnDialogModule { }
